import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { FormattedDate } from 'react-intl';
import { Link } from 'react-router';

class ModuleContentMain extends Component {

    render() {

        let mainContent = [];

        if (this.props.module.validFrom) {
            const released = (<FormattedDate value={this.props.module.validFrom} year="numeric" month="long" day="numeric" />);
            mainContent.push(
                <div key="validFrom">
                    <h4>Released on <span>{released}</span></h4>
                    <p><em>{this.props.module.views} views</em></p>
                </div>
            );
        }
        if (!!this.props.module.description) {
            mainContent.push(
                <div key='description'>
                    {this.props.module.description.split('\n').map((item, key) => <p key={key}>{item}</p>)}
                </div>
            );
        }
        if (!!this.props.module.overview) {
            mainContent.push(
                <div key='overview'>
                    <h4>Overview</h4>
                    {this.props.module.overview.split('\n').map((item, key) => <p key={key}>{item}</p>)}
                </div>
            );
        }

        mainContent.push(
            <div key='category'>
                <p><b>Category: </b>
                    <Link
                        to={`/dashboard/library/${this.props.module.categoryId || "uncategorised"}`}>
                        {this.props.module.category || 'Uncategorised'}
                    </Link>
                </p>
            </div>
        );

        if (!!this.props.module.url) {
            mainContent.push(
                <div key="url">
                    <p><Link to={this.props.module.url} target="_blank">{this.props.module.url}</Link></p>
                </div>
            );
        }

        let content = null;
        if (mainContent.length > 0) {
            content = (<div className="content-main" key="contentMain">{mainContent}</div>);
        }
        return content;
    }
}

ModuleContentMain.propTypes = {
    module: PropTypes.object,
};

ModuleContentMain.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default ModuleContentMain;

